/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Api_GenericInputs */

const cs_enum_api_generic = /** @type {(inputs: Enum_Api_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API`)
};

const en_enum_api_generic = /** @type {(inputs: Enum_Api_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API`)
};

/**
* | output |
* | --- |
* | "API" |
*
* @param {Enum_Api_GenericInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_api_generic = /** @type {((inputs?: Enum_Api_GenericInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Api_GenericInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_api_generic(inputs)
	return cs_enum_api_generic(inputs)
});